import React from 'react';
import { ToastManager, TOAST_TYPES } from '../../fasades/toastmanager';
import './toast.css';

interface Props 
{
    id      : number;
    message : string;
    key     : number;
    type    : TOAST_TYPES;
}

export class Toast extends React.Component<Props> {

    getToastIcon() {
        switch (this.props.type) {
            case TOAST_TYPES.SUCCESS:
                return '✓';
            case TOAST_TYPES.ERROR:
                return '✕';
            case TOAST_TYPES.WARNING:
                return '⚠';
            case TOAST_TYPES.INFO:
                return 'ℹ';
            default:
                return '•';
        }
    }

    handleRemove()
    {
        ToastManager.removeToast(this.props.id);
    }

    render() {
        const toastClass = `toast toast-${this.props.type}`;

        return (
            <div className={toastClass} style={{ position: 'relative' }}>
                <div className="toast-content">
                    <span className="toast-icon">{this.getToastIcon()}</span>
                    <span className="toast-message">{this.props.message}</span>
                </div>
                <button
                    className   = "toast-close"
                    onClick     = { () => this.handleRemove() }
                    aria-label  = "Close toast"
                >
                    ×
                </button>
            </div>
        );
    }
}


